import * as z from 'zod';

export const MimeType = {
  GIF: 'image/gif',
  JPG: 'image/jpeg',
  PNG: 'image/png',
} as const satisfies Record<string, string>;
export type MimeType = (typeof MimeType)[keyof typeof MimeType];

export const Extension = {
  GIF: 'gif',
  JPG: 'jpg',
  PNG: 'png',
} as const satisfies Record<string, string>;
export type Extension = (typeof Extension)[keyof typeof Extension];

const MimeType_Extension_MAP: Record<MimeType, Extension> = {
  [MimeType.GIF]: Extension.GIF,
  [MimeType.JPG]: Extension.JPG,
  [MimeType.PNG]: Extension.PNG,
} as const satisfies Record<MimeType, Extension>;

export const mimeTypeToExtension = (mimeType: MimeType): Extension => {
  return MimeType_Extension_MAP[mimeType];
};

export const mimeTypeSchema = z.enum([MimeType.JPG, MimeType.GIF, MimeType.PNG]);
